import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import { useWebSocket } from '../contexts/WebSocketContext'

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()
  const { connected } = useWebSocket()

  return (
    <div className="min-h-screen bg-canvas flex flex-col">
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      <div className="lg:pl-64 flex-1 flex flex-col min-h-screen">
        <Header onMenuClick={() => setSidebarOpen(true)} connected={connected} />

        {/* Page content — gentle per-route entrance; keyed on path */}
        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
          <div key={location.pathname} className="mx-auto max-w-[1280px] animate-rise">
            <Outlet />
          </div>
        </main>

        <Footer variant="compact" />
      </div>

      {/* Mobile scrim */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-ink-950/40 backdrop-blur-sm z-40 lg:hidden animate-fade-in"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  )
}

export default Layout
